// extracted by mini-css-extract-plugin
export default {"categoryBox":"c4_mc","categoryHeader":"c4_md","boxTitle":"c4_mf","categoryText":"c4_mg","showFullCategory":"c4_mh"};